import { Controller } from "@hotwired/stimulus"
import { confirmDialog } from "../app/turbo_confirm"

// Manages checkbox selection state for bulk operations on data tables.
//
// Usage:
//   <div data-controller="bulk-select">
//     <table>
//       <thead>
//         <tr>
//           <th><input type="checkbox" data-action="change->bulk-select#toggleAll" data-bulk-select-target="selectAll"></th>
//         </tr>
//       </thead>
//       <tbody>
//         <tr>
//           <td><input type="checkbox" data-action="change->bulk-select#toggle" data-bulk-select-target="checkbox" value="1"></td>
//         </tr>
//       </tbody>
//     </table>
//     <div data-bulk-select-target="actionBar" class="bulk-action-bar" style="display: none;">
//       <span data-bulk-select-target="count">0</span> selected
//       <button data-action="click->bulk-select#performAction" data-url="/admin/items/bulk_destroy" data-method="delete">Delete</button>
//     </div>
//   </div>
//
export default class extends Controller {
  static targets = ["checkbox", "selectAll", "actionBar", "count"]

  connect() {
    this.updateUI()
  }

  toggle() {
    this.updateUI()
  }

  toggleAll() {
    const checked = this.selectAllTarget.checked
    this.checkboxTargets.forEach(cb => { cb.checked = checked })
    this.updateUI()
  }

  updateUI() {
    const selected = this.selectedIds()
    const count = selected.length

    if (this.hasCountTarget) {
      this.countTarget.textContent = count
    }

    if (this.hasActionBarTarget) {
      this.actionBarTarget.style.display = count > 0 ? 'flex' : 'none'
    }

    if (this.hasSelectAllTarget) {
      const total = this.checkboxTargets.length
      this.selectAllTarget.checked = total > 0 && count === total
      this.selectAllTarget.indeterminate = count > 0 && count < total
    }

    // Highlight selected rows
    this.checkboxTargets.forEach(cb => {
      const row = cb.closest('tr')
      if (row) {
        row.classList.toggle('table-active', cb.checked)
      }
    })
  }

  selectedIds() {
    return this.checkboxTargets
      .filter(cb => cb.checked)
      .map(cb => cb.value)
  }

  clearAll() {
    this.checkboxTargets.forEach(cb => { cb.checked = false })
    if (this.hasSelectAllTarget) this.selectAllTarget.checked = false
    this.updateUI()
  }

  async performAction(event) {
    event.preventDefault()
    const btn = event.currentTarget
    const url = btn.dataset.url
    const method = (btn.dataset.method || 'PATCH').toUpperCase()
    const ids = this.selectedIds()

    if (ids.length === 0) return

    const confirmMsg = btn.dataset.confirm
    if (confirmMsg && !(await confirmDialog(confirmMsg))) return

    const csrfToken = document.querySelector('meta[name="csrf-token"]')
    fetch(url, {
      method: method === 'GET' ? 'POST' : method,
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': csrfToken ? csrfToken.content : '',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ ids: ids })
    })
    .then(response => {
      if (response.ok) {
        window.location.reload()
      } else {
        response.json().then(data => {
          alert(data.message || 'Operation failed') // nosemgrep
        }).catch(() => {
          alert('Operation failed') // nosemgrep
        })
      }
    })
    .catch(error => {
      console.error("Bulk action failed:", error)
    })
  }
}
